define('usuario-dashboard-controller',[
    'usuario-dashboard-resource',
    'imovel-resource',
    'crud-service'

], function() {

  var app = angular.module('usuario.dashboard.controller', [
    'usuario.dashboard.resource',
    'imovel.resource',
    'crud.service'
  ]);



  app.controller('UsuarioDashboardController', ['$scope', 'UsuarioDashboard','crud','Imovel',  function($scope, UsuarioDashboard, crud, Imovel ) {


    $scope.solicitacaoListModal = false;
    $scope.chaves = [];
    $scope.getSolicitacoesChave = function(){
      $scope.formAtual = 'solicitacaoChavesList';
      $scope.formName = 'Solicitação de chaves listagem';
      $scope.chaves = [];
      Imovel.getSolicitacoesChave({}).then(function (result) {
        if(result.data.chaves){
          $scope.chaves = result.data.chaves;
        }
      });
    };

    $scope.showSolicitacoesList = function() {
      $scope.solicitacaoListModal = true;
    };

    $scope.cancelarSolicitacao = function(so_codigo){
      Imovel.cancelarSolicitacaoChave({so_codigo: so_codigo}).then(function (result) {
        $scope.solicitacaoListModal = false;
       $scope.getSolicitacoesChave();
      });
    };


    $scope.getSolicitacoesChave();
  }]);


});

